import { hostnameRegex } from 'config/pathRegex';
import languages from 'config/types/language';
import sanitizeHtml from 'sanitize-html';
import values from 'lodash/fp/values';

const isAnchorLink = (url) => '#' === url[0];
const magazineUrlRegex = hostnameRegex.toString().replace('$', `/(${values(languages).join('|')})/magazine/`);
// Stripping away the `/` at the beginning and end of the stringified regexp asthe RegExp constructor doesn't handle them
const isMagazineUrl = (url) =>
  new RegExp(magazineUrlRegex.substring(1, magazineUrlRegex.length - 1)).test(url);

const removeLinks = (articleContent) => {
  if (!articleContent.includes('<a')) {
    return articleContent;
  }

  return sanitizeHtml(articleContent, {
    allowedTags: false, // Don't filter out any tags
    allowedAttributes: false, // Don't filter out any attributes
    allowVulnerableTags: true,
    transformTags: {
      a(tagName, attribs) {
        const { target, ...attributesWithoutTarget } = attribs;
        if (!attributesWithoutTarget.href) {
          // Render the tag as-is but without a "target" attribute
          return { tagName, attribs: attributesWithoutTarget };
        }

        const { href } = new URL(attributesWithoutTarget.href, window.location.href);
        if (isAnchorLink(href) || isMagazineUrl(href)) {
          // Render the tag as-is but without a "target" attribute
          return { tagName, attribs: attributesWithoutTarget };
        }

        // Convert to a <span> with no attributes
        return { tagName: 'span' };
      },
    },
  });
};

export default removeLinks;
